module.exports = __webpack_public_path__ + "Poster1-Ethnography1.png?bb4b5f7dec78ae7841b2568e20525e11";


//////////////////
// WEBPACK FOOTER
// ./static/Poster1-Ethnography1.png
// module id = 341
// module chunks = 0